import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Typography } from 'shared/ui'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/styles.module.scss'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { type HandOffActionWidgetStore } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/ui/HandOffActionWidget/store/handOffActionWidgetStore.ts'
import { useWidgetKeyboard } from 'pages/chatbot/ui/UnifiedAgent/hooks/useWidgetKeyboard.ts'

export const HandoffNotifyStep = observer(({ store }: { store: HandOffActionWidgetStore }) => {
  const { isNotifyEnabled, onSelectNotify, handoffNotifySettingsStore, setHint } = store
  useWidgetKeyboard({
    onNavigate: () => {
      handoffNotifySettingsStore.setNotifyTeamMembers(!isNotifyEnabled)
    },
    onEnter: () => {
      onSelectNotify(isNotifyEnabled)
    },
    onEscape: store.handleClose,
  })
  useEffect(() => {
    setHint(['↑↓ to navigate', 'Enter to select', 'Esc to skip'])
    return () => {
      setHint([])
    }
  }, [])
  return (
    <div className={styles.list}>
      <WidgetItem isFocused={isNotifyEnabled} badgeIndex={0} onClick={() => onSelectNotify(true)}>
        <Typography variant={'body-rg-regular'} ariaLabel={'Yes'}>
          Yes
        </Typography>
      </WidgetItem>
      <WidgetItem isFocused={!isNotifyEnabled} badgeIndex={1} onClick={() => onSelectNotify(false)}>
        <Typography variant={'body-rg-regular'} ariaLabel={'No'}>
          No
        </Typography>
      </WidgetItem>
    </div>
  )
})
